<template>
  <div class="ai-interactive">
    <!-- <div class="nav-bar">
      <i class="mint-cell-allow-left"></i>
      <span>客服中心</span>
      <img src="../../assets/question-close-icon.png" alt="">
    </div>  :auto="0"-->

    <!-- <mt-header title="客服中心" class="nav-bar">
      <router-link to="/" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
      <img slot="right" src="../../assets/question-close-icon.png" alt="">
    </mt-header> -->
    <top
      :iskf="true"
      :isOrder="true"
      @intoIm="goChat">
    </top>
    <!-- <div class="nav">
      <router-link style="color:rgb(31, 55, 61);"  :to="{ path: '/aiInteractive'}">
          <span>首页</span>
      </router-link> -->
        <!-- <span class="navbread" v-for="item in questionclass">{{'>'+item}}</span> -->
      <!-- <router-link class="btna color" :to="{ path: '/myorder'}" :style="{backgroundColor:boxBodyColor}">我的工单</router-link> -->
    <!-- </div> -->
    <div class="top-carousel" v-if="carouselList && carouselList.length">
      <el-carousel height="200px" indicator-position="none">
        <el-carousel-item v-for="(item, index) in carouselList" :key="item" @click.native="swipeClick(item)">
          <img :src="item.imgUrl"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="ai-left-content">
      <!-- 热点问题 -->
      <div class="hot-question">
        <div class="hot-top-content">
          <div class="hot-title">
            <span>热点问题</span><img src="../../assets/hot-icon.png" alt="">
          </div>
          <div class="toggle-content" @click="toggles" v-if="total > hotParams.size">
            <!-- <img src="../../assets/toggle-icon.png" alt=""> -->
            <i class="icon iconfont icon-Toggle" :style="{color:boxBodyColor}"></i>
            <span :style="{color: boxBodyColor}">换一换</span>
          </div>
        </div>
        <div class="hot-btm-content">
          <div class="hot-item-content" v-for="(item,i) in hotList" :key="item.id">
            <div class="hot-item" @click="hotClick(item)">
              <p>{{ item.name }}</p>
              <div class="hot-btm-right">
                <span>查看详情</span>
                <img src="../../assets/receipt-item-right.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ai-right-content">
      <!-- 问题类型 -->
      <div class="question-type">
        <div class="question-type-content">
          <div class="type-title">全部问题类型</div>
          <div class="type-btm-content">
            <div class="type-item" v-for="(item,i) in questionType" :key="item.id" @click="itemClick(item)">
              <span>{{ item.questionName }}</span><i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import 'swiper/swiper.css'
import Api from '../../api/question'
import Top from '../common/top.vue'
import * as Url from '@/components/url.js'
import { mapGetters } from 'vuex'
export default {
  name: 'aiInteractive',
  components: {
    Top
  },
  data () {
    return {
      // swiperOption: {
      //   loop: true,
      //   autoplay: {
      //     delay: 3000,
      //     stopOnLastSlide: false,
      //     disableOnInteraction: false
      //   },
      //   // 显示分页
      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true //允许分页点击跳转
      //   },
      //   // 设置点击箭头
      //   navigation: {
      //     nextEl: ".swiper-button-next",
      //     prevEl: ".swiper-button-prev"
      //   }
      // },
      basicUrl: Url.baseurl,
      hotParams: {
        page: 1,
        size: 6
      },
      hotList: [],
      totalPages: 0,
      total: 0,
      carouselList: [],
      currentIndex: 0,
      questionType: [],
      isIm: false,
      isSpirit: false,
      boxBodyColor:''
    }
  },
  computed: {
    ...mapGetters({
      model: 'model',
      chatType: 'chatType'
    }),
  },
  created() {
    this.boxBodyColor = sessionStorage.getItem('boxBodyColor')
    this.init()
    this.getHotList()
    // this.getImStatus()
  },
  methods: {
    init() {
      Api.getCarousel(this.$route.query.v, res => {
        if (res.code === 1) {
          this.carouselList = res.data.carousel
          this.questionType = res.data.questionType
        }
      })
    },
    getImStatus() {
      // Api.getEnable({visitorMd5Code: this.$route.query.v}, res => {
      //   if (res.code === 1) {
      //     this.isIm = res.data.im
      //     this.isSpirit = res.data.spirit
      //   }
      // })
    },
    getHotList() {
      Api.getHotList({
        visitorMd5Code: this.$route.query.v,
        ...this.hotParams
      }, res => {
        if (res.code === 1) {
          this.hotList = res.data.content
          this.totalPages = res.data.totalPages
          this.total = res.data.total
        }
      })
    },
    toggles() {
      if (this.total <= this.hotParams.size) {
        return
      }
      this.hotList = []
      if (this.totalPages > this.hotParams.page) {
        this.hotParams.page++
        this.getHotList()
      } else {
        this.hotParams.page = 1
        this.getHotList()
      }
    },
    handleChange(index) {
      this.currentIndex = index
    },
    swipeClick(item) {
      // 点击轮播图日志埋点
      this.$Points.point({code: '1001', type: '2', id: item.id});
      switch(item.action) {
        // 外链
        case 1:
          location.href = item.skipUrl
          break;
        case 2:
          this.$router.push({
            path: '/faqPage',
            query: {
              type: 'swipe',
              id: item.id,
              v: this.$route.query.v
            }
          })
          break;
      }
    },
    commonChat(source, item) {
      let obj = {}
      switch(this.model) {
        case 1:
          obj = {
            path: '/spirit',
            query: {
              v: this.$route.query.v,
              chatType: true,
              id: item && item.id ? item.id : ''
            }
          }
          break;
        case 2:
          if (!source) {
            if (this.chatType) {
              obj = {
                path: '/imSession',
                query: {
                  v: this.$route.query.v
                }
              }
            } else {
              obj = {
                path: '/imLineUp',
                query: {
                  v: this.$route.query.v
                }
              }
            }
          } else {
            obj = {
              path: '/imChat',
              query: {
                v: this.$route.query.v,
                id: item && item.id ? item.id : '',
                chatType: this.chatType,
              }
            }
          }
          break;
        case 3:
          if (!source) {
            if (this.chatType) {
              obj = {
                path: '/imSession',
                query: {
                  v: this.$route.query.v
                }
              }
            } else {
              obj = {
                path: '/spirit',
                query: {
                  v: this.$route.query.v
                }
              }
           }
          } else {
            obj = {
              path: '/spirit',
              query: {
                v: this.$route.query.v,
                chatType: this.chatType,
                id: item && item.id ? item.id : ''
              }
            }
          }
          break;
      }
      if (source) {
        obj.query.source = source
      }
      this.$router.push(obj)
    },
    goChat() {
      // 点击客服日志埋点
      this.$Points.point({code: '1001', type: '5'});
      this.$store.dispatch({
        type: 'getEnable',
        visitorMd5Code: this.$route.query.v,
      }).then(res => {
        this.commonChat()
      })
    },
    // 热点问题
    hotClick(item) {
      // 点击热点日志埋点
      this.$Points.point({code: '1001', type: '1', id: item.id});
      this.$store.dispatch({
        type: 'getEnable',
        visitorMd5Code: this.$route.query.v,
      }).then(res => {
        this.commonChat('hot', item)
      })
    },
    itemClick(item) {
      // 点击问题类型日志埋点
      this.$Points.point({code: '1001', type: '3', id: item.id});
      this.$store.dispatch({
        type: 'getEnable',
        visitorMd5Code: this.$route.query.v,
      }).then(res => {
        switch(item.type) {
          // 外链
          case 1:
            location.href = item.url
            break;
          case 2:
            if (item.isAi) {
              this.commonChat('type', item)
            } else {
              this.$router.push({
                path: '/faqPage',
                query: {
                  id: item.id,
                  v: this.$route.query.v,
                  type: 'type'
                }
              })
            }
            break;
          case 3:
            let ailink = ''
            if (this.model == 2) {
              ailink = 'imChat'
            } else {
              ailink = 'spirit'
            }
            this.$router.push({
              path: '/receipt',
              query: {
                id: item.id,
                v: this.$route.query.v,
                source: 'type',
                chatType: this.chatType,
                ailink
              }
            })
            break;
            // 工单
          case 4:
            if (item.showNote) {
              this.$router.push({
                path: '/workinformation',
                query: {
                  name: item.workerOrderName,
                  source: 'type',
                  id: item.workerOrderId,
                  v: this.$route.query.v
                }
              })
            } else {
              this.$router.push({
                path: '/workcommit',
                query: {
                  name: item.workerOrderName,
                  source: 'type',
                  id: item.workerOrderId,
                  v: this.$route.query.v
                }
              })
            }
            break;
        }
      })
    }
  }
}
</script>
<style scoped>
.ai-interactive {
	height: 100%;
	padding-bottom: 50px;
	box-sizing: border-box;
	background: fixed url(/pc/static/assets/question-nav.png) no-repeat;
	background-size: 100% auto;
	background-color: #F8F9FC;
  overflow: auto;
}
.ai-interactive::-webkit-scrollbar {
  display: none;
}
.ai-interactive::after {
	content: '';
	display: block;
	clear: both;
}
.ai-interactive .top-carousel {
  height: 200px;
  padding: 20px 15px 0 15px;
}
.ai-interactive .top-carousel .mint-swipe-items-wrap > div {
	padding: 0 15px;
	box-sizing: border-box;
}
.ai-interactive .top-carousel img {
	width: 100%;
	height: 100%;
	border-radius: 8px;
}
.ai-interactive .top-carousel img.active {
	transform: scale(1.05);
}
.ai-interactive .nav-bar {
	color: #333;
	background-color: transparent;
}
.ai-interactive .nav-bar a {
	color: #333;
}
.ai-interactive .nav-bar .mint-header-title {
	color: #333;
}
.ai-interactive .nav-bar img {
	width: 20px;
	height: 20px;
}
.ai-interactive .hot-question {
  padding: 20px 0;
	margin-bottom: 10px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid #fff;
  border-radius: 8px;
}
.ai-interactive .hot-question .hot-top-content {
	padding: 0 15px;
	display: flex;
	justify-content: space-between;
}
.ai-interactive .hot-question .hot-top-content .hot-title {
	display: flex;
	align-items: center;
}
.ai-interactive .hot-question .hot-top-content .hot-title span {
	font-size: 16px;
  font-weight: 600;
	margin-right: 6px;
}
.ai-interactive .hot-question .hot-top-content .hot-title img {
	width: 12px;
}
.ai-interactive .hot-question .hot-top-content .toggle-content {
	display: flex;
	align-items: center;
  cursor: pointer;
}
.ai-interactive .hot-question .hot-top-content .toggle-content span {
	font-size: 12px;
	color: #007AFF;
}
.ai-interactive .hot-question .hot-top-content .toggle-content i {
	font-size: 12px;
  color: #007AFF;
	margin-right: 6px;
}
.ai-interactive .hot-question .hot-top-content .toggle-content img {
	width: 12px;
	margin-right: 6px;
}
.ai-interactive .hot-question .hot-btm-content {
	display: flex;
	flex-wrap: wrap;
	padding: 0 10px;
	margin-top: 15px;
}
.ai-interactive .hot-question .hot-btm-content .hot-item-content {
	width: 50%;
	padding: 0 5px;
	box-sizing: border-box;
}
.ai-interactive .hot-question .hot-btm-content .hot-item {
	height: 65px;
  padding: 4px 12px;
	margin-bottom: 8px;
	background: #fff;
  border: 1px solid #E5E9EF;
	border-radius: 4px;
	position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  cursor: pointer;
}
.ai-interactive .hot-question .hot-btm-content .hot-item p {
	font-size: 14px;
  font-weight: 600;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.ai-interactive .hot-question .hot-btm-content .hot-item i {
	font-size: 15px;
	color: #333;
}
.ai-interactive .hot-question .hot-btm-content .hot-item i::after {
	border: 2px solid #333;
	border-bottom-width: 0;
	border-left-width: 0;
	right: 15px;
}
.ai-interactive .hot-question .hot-btm-content .hot-item .hot-btm-right {
  display: flex;
  align-items: center;
  justify-content: end;
}
.ai-interactive .hot-question .hot-btm-content .hot-item .hot-btm-right span {
  font-size: 12px;
  color: #007AFF;
}
.ai-interactive .hot-question .hot-btm-content .hot-item .hot-btm-right img {
  height: 10px;
  margin-left: 7px;
}
.ai-interactive .question-type {
	padding: 0 15px;
}
.ai-interactive .question-type .question-type-content {
	background: rgba(255, 255, 255, 0.5);
  border: 1px solid #fff;
	border-radius: 8px;
	padding: 12.5px 15px;
	position: relative;
}
.ai-interactive .question-type .type-title {
	height: 40px;
	font-size: 16px;
  font-weight: 600;
	border-bottom: 1px solid #F0F0F3;
	display: flex;
	align-items: center;
	position: relative;
	z-index: 10;
}
.ai-interactive .question-type .type-btm-content {
  padding: 0 10px;
  background: #FFFFFF;
  border-radius: 4px;
	position: relative;
	z-index: 10;
}
.ai-interactive .question-type .type-btm-content .type-item {
	height: 40px;
	font-size: 13px;
	position: relative;
	border-bottom: 1px solid #F0F0F3;
	display: flex;
	align-items: center;
	justify-content: space-between;
  cursor: pointer;
}
.ai-interactive .question-type .type-btm-content .type-item span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ai-interactive .question-type .type-btm-content .type-item i {
	font-size: 11px;
}
.ai-interactive .question-type .type-btm-content .type-item i::after {
	right: 2px;
}
.ai-interactive .btm-btns {
	padding: 0 15px;
	display: flex;
	justify-content: space-between;
	margin-top: 20px;
}
.ai-interactive .btm-btns .btm-btn {
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
.ai-interactive .btm-btns .btm-btn .btn-icon {
	width: 20px;
	height: 20px;
	vertical-align: middle;
	margin-top: -2px;
	margin-right: 5px;
}
.ai-interactive .btm-btns .left-content {
	width: 50%;
	padding-right: 10px;
}
.ai-interactive .btm-btns .right-content {
	width: 50%;
	padding-left: 10px;
}
.ai-interactive .btm-btns .btm-left {
	color: #007AFF;
	background-color: #fff;
	border: none;
	box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.06);
}
.ai-interactive .btm-btns .btm-left .mint-button-text {
	color: #007AFF;
}
.ai-interactive .ai-left-content {
  margin-top: 15px;
  padding: 0 15px;
  box-sizing: border-box;
}
.ai-interactive {
  padding-bottom: 0;
  margin-bottom: 50px;
}
.ai-interactive .ai-left-content {
  width: 50%;
  float: left;
  margin-top: 15px;
  padding-left: 15px;
  padding-right: 0;
  box-sizing: border-box;
}
.ai-interactive .ai-right-content {
  width: 50%;
  height: 348px;
  float: left;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
}
.ai-interactive .ai-right-content .question-type {
  flex: 1;
}
.ai-interactive .ai-right-content .question-type .question-type-content .type-btm-content {
  height: 230px;
  overflow: auto;
}
.ai-interactive .ai-right-content .question-type .question-type-content .type-btm-content::-webkit-scrollbar {
  display: none;
}
.nav {
  width: 95%;
  margin:0 auto;
  height: 45px;
  border-bottom: 1px solid #000;
  font-size: 14px;
}
.nav span {
  line-height: 45px;
  color: #5987c2;
  font-weight:bold;
  text-decoration: underline;
}
.nav .btna {
  display: block;
  color: white;
  font-size: 14px;
  width: 70px;
  height: 24px;
  float: right;
  border-radius: 4px;
  text-align:center;
  line-height: 24px;
  margin-top: 11px;
}
.nav .navbread {
  text-decoration: none;
  color: #000;
  font-weight:bold;
}
</style>





// WEBPACK FOOTER //
// src/components/question/aiInteractive.vue?5456cb56